// extracted by mini-css-extract-plugin
module.exports = {"actions":"TableSearchAndPagination_actions_1Iqcf","footer":"TableSearchAndPagination_footer_1Bs3G"};